export var ABTEST = 'ABTest';
export var ACCORDION = 'Accordion';
export var ANCHORLINK = 'AnchorLink';
export var ANCHORLINKTARGET = 'AnchorLinkTarget';
export var APOLLOINTEGRATIONCANARY = 'ApolloIntegrationCanary';
export var AUTHLINK = 'AuthLink';
export var AUTOINSURANCEENTRYPOINT = 'AutoInsuranceEntryPoint';
export var AUTOINSURANCEQUOTES = 'AutoInsuranceQuotes';
export var BACKTOTOPLINK = 'BackToTopLink';
export var BUTTON = 'Button';
export var CALCULATION = 'Calculation';
export var CALCULATOR = 'Calculator';
export var CALCULATORCONDITIONAL = 'CalculatorConditional';
export var CALCULATORINPUT = 'CalculatorInput';
export var CALCULATORRADIO = 'CalculatorRadio';
export var CALCULATORSELECT = 'CalculatorSelect';
export var COLUMNS = 'Columns';
export var CONTAINER = 'Container';
export var CONTENTHEADING = 'ContentHeading';
export var CONTENTIMAGE = 'ContentImage';
export var CONTENTQUOTE = 'ContentQuote';
export var DIVIDER = 'Divider';
export var DOCUMENT = 'Document';
export var DROPCAPS = 'DropCaps';
export var FAQ = 'FAQ';
export var HEADING = 'Heading';
export var HLMENTRY = 'HlmEntry';
export var HOMEINSURANCEENTRYPOINT = 'HomeInsuranceEntryPoint';
export var HOUSEAD = 'HouseAd';
export var IMAGE = 'Image';
export var LINK = 'Link';
export var LIST = 'List';
export var LISTITEM = 'Li';
export var MARKETPLACEAPPLYNOW = 'MarketplaceApplyNow';
export var MARKETPLACECOMPARISONLINK = 'MarketplaceComparisonLink';
export var MARKETPLACECOMPARISONTABLE = 'MarketplaceComparisonTable';
export var MARKETPLACEENTITYDISPLAYNAME = 'MarketplaceEntityDisplayName';
export var MARKETPLACEFIELD = 'MarketplaceField';
export var MARKETPLACEPARTNERPLACEMENT = 'MarketplacePartnerPlacement';
export var MARKETPLACEPRODUCTCARD = 'MarketplaceProductCard';
export var MARKETPLACESTARRATING = 'MarketplaceStarRating';
export var MARKETPLACERATETABLE = 'MarketplaceRateTable';
export var MINIPRODUCTCARD = 'MiniProductCard';
export var MORELINK = 'MoreLink';
export var NERDTIP = 'NerdTip';
export var NOOP = 'NoOp';
export var OUTOFDATEMESSAGE = 'OutOfDateMessage';
export var POSTLIST = 'PostList';
export var PREQUALAPPLICATIONHOUSEAD = 'PrequalApplicationHouseAd';
export var PRODUCTSTARRATING = 'ProductStarRating';
export var RENDERCONTEXTCONDITIONAL = 'RenderContextConditional';
export var SCREENSIZECONDITIONAL = 'ScreenSizeConditional';
export var SPOTIFY = 'Spotify';
export var STARRATING = 'StarRating';
export var TABLE = 'Table';
export var TABLEOFCONTENTS = 'TableOfContents';
export var TABLEOFCONTENTSTARGET = 'TableOfContentsTarget';
export var TYPE = 'Type';
export var USERSEGMENTCONDITIONAL = 'UserSegmentConditional';
export var VIDEO = 'Video';
export var WPCALCULATOR = 'WPCalculator';
export var WPEMBED = 'WPEmbed';
export var WPHOUSEAD = 'WPHouseAd';
export var WPPOSTLIST = 'WPPostList';
export var WPTABLE = 'WPTable';